import { render, staticRenderFns } from "./success-card.component.vue?vue&type=template&id=5c4851d4&scoped=true&"
import script from "./success-card.component.vue?vue&type=script&lang=ts&"
export * from "./success-card.component.vue?vue&type=script&lang=ts&"
import style0 from "./success-card.component.vue?vue&type=style&index=0&id=5c4851d4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4851d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
